import React from 'react'
import { css, cx, useTheme } from '@fable/theme'
import { Folio } from '@fable/types'
import { Text } from '@fable/components'
import { usePreloadImage } from '@fable/hooks'
import AudioPlayer from '../../../../../components/audio_player/AudioPlayer'

import { useActions } from '../../../../../hooks/useActions'
import { useSidebar } from '../../../../../hooks'

interface Props {
  info: Folio
}

export const FolioMasthead: React.VFC<Props> = ({ info }) => {
  const { openModal } = useActions()
  const { isSidebarActive } = useSidebar()
  const { colors } = useTheme()

  const { curator, name, color, cover_image, secondary_image } = info
  const curatorBioTitle = 'About the Curator'
  const curatorImage = usePreloadImage(curator.image)

  const renderAudioPlayer = () => {
    if (!info.audio) return null

    return (
      <AudioPlayer
        source={info.audio}
        title={info.audio_title}
        active={!isSidebarActive}
        simple
      />
    )
  }

  return (
    <section>
      <div className="content">
        <div className="folio-image">
          <div
            className="image curator"
            style={{ backgroundImage: `url(${curatorImage?.src})` }}
          >
            <div className="figures">
              <img
                className="figure main"
                src={cover_image}
                alt={`${name} Figure`}
              />
              <img
                className="figure sub"
                src={secondary_image}
                alt={`${name} Figure`}
              />
            </div>
          </div>
          <div className="image shadow"></div>
        </div>
        <div className="folio-info">
          <Text
            className="title"
            type="header"
            sizing="XL"
            text={name}
            tag="h1"
          />
          <Text
            className="curator-name"
            type="subhead"
            sizing={{ base: 'XS', mobileL: 'S' }}
            color={color}
            tag="h4"
          >
            Curated by {curator.display_name}
          </Text>
          {renderAudioPlayer()}
          <hr className="fds-ui--divider" />
          <div className="curator-info">
            <Text className="curator-bio-label" type="label" sizing="L">
              {curatorBioTitle}
            </Text>
            <div
              className={css`
                margin: 6px 0 16px;
                cursor: pointer;
              `}
              onClick={() =>
                openModal(
                  <p className={cx(styles.modalBio)}>{curator.bio}</p>,
                  'm-card'
                )
              }
            >
              <Text
                type="body"
                sizing="M"
                color={colors.greyStrong}
                truncate={2}
                text={curator.bio}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

const styles = {
  modalBio: css`
    padding: 30px;
    max-width: 420px;
  `,
}
